import { render, staticRenderFns } from "./availableCreativesTable.vue?vue&type=template&id=92776930&scoped=true&lang=pug"
import script from "./availableCreativesTable.vue?vue&type=script&lang=js"
export * from "./availableCreativesTable.vue?vue&type=script&lang=js"
import style0 from "./availableCreativesTable.vue?vue&type=style&index=0&id=92776930&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92776930",
  null
  
)

export default component.exports